module.exports = {"namespace":"merchant.orders","id":"modules-merchant-orders","production":{"baseUrl":"http://localhost:8089"},"homologation":{"baseUrl":"http://localhost:8089"},"development":{"baseUrl":"http://localhost:8089"}}


//////////////////
// WEBPACK FOOTER
// ./src/Module.json
// module id = 117
// module chunks = 0